export default {
    formatNumber(num, decimal) {
        const options = { 
            minimumFractionDigits: decimal||decimal>=0? decimal: 2,
            maximumFractionDigits: decimal||decimal>=0? decimal: 2,
        }
        return Number(num).toLocaleString('en', options)
    }
}
